<div class="sidebar included">
    <app-sidebar-header [title]="'priceBreakdown.title.priceBreakdown' | ibeadmin | async"></app-sidebar-header>

    <app-loading *ngIf="!isBookedTripLoaded"></app-loading>

    <ng-container *ngIf="isBookedTripLoaded && !hasBookedTripRetrievalError">
        <div class="sidebar__body sl--scrollable" #sidebar__body>

            <!--
			<app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" [close]="true"
				[title]="'priceBreakdown.title.priceHasBeenUpdated' | ibeadmin | async" *ngIf="INDRA_priceChange()">
				<div message>
					<p>{{ 'priceBreakdown.text.passengerPriceChange' | ibeadmin | async }}</p>  {{ 'priceBreakdown.text.checkNewPrice' | ibeadmin | async }}
				</div>
			</app-notification>
			<app-notification class="bottom-gap display--block" [style]="'note'"
			 [icon]="'icons.svg#money_related--discount'" [title]="'priceBreakdown.title.paxPriceHasBeenUpdated' | ibeadmin | async" *ngIf="hasUpdatedFlightPrices && !isTTTBookingForCompletion">
				<div message>
					<span>{{ 'priceBreakdown.text.oneOrMorePassengersAreMember' | ibeadmin | async }} {{paxTierListString}} {{ 'priceBreakdown.text.oneOrMorePassengersAreMember2' | ibeadmin | async }}</span> <br />
					<span>{{ 'priceBreakdown.text.pleaseCheckNewPrice' | ibeadmin | async }}</span>
				</div>
			</app-notification>
			-->

            <!-- Flights -->
            <ng-container *ngIf="booked_trip_flights.length > 0">
                <div class="price-breakdown-list--title">{{ 'priceBreakdown.text.flights' | ibeadmin | async }}</div>

                <ng-container *ngIf="booked_trip.booking_type !== 'M'">
                    <ng-container *ngFor="let flight of booked_trip_flights; let i = index">
                        <div class="price-breakdown-count">
                            <app-svg [svg]="flight.item.logo" [alt]="'priceBreakdown.alt.airlineLogo' | ibeadmin | async" class="price-breakdown__airline"></app-svg>
                            <div class="price-breakdown-label">
                                <div class="price-breakdown-title">
                                    <span class="destination">
										{{ bookingSteps[i]._departure.location.city }} -
										{{ bookingSteps[i]._arrival.location.city }}
										<p class="muted">
											<a class="text-link" (click)="INDRA_handleDetailsClick(flight.item.details)" href="javascript:;" role="button">
												{{ 'priceBreakdown.link.details' | ibeadmin | async }}
											</a>
										</p>
									</span>
                                    <span class="datetime">{{ flight.item.flightDate | titlecase }}</span>
                                </div>
                                <!--
								<div class="tag" *ngIf="INDRA_priceChange()">{{ 'priceBreakdown.text.newPrice' | ibeadmin | async }}</div>
								<div class="price-right line-through" *ngIf="INDRA_priceChange()">
									{{ INDRA_getFlightPrice(flight) | indracurrency }}
								</div>
								-->
                                <div class="price-right" *ngIf="!bookAwardFlights && INDRA_isNonZeroPriceFlight()">
                                    {{ flight.item.price | indracurrency }}
                                </div>
                                <div *ngIf="bookAwardFlights && INDRA_isNonZeroPriceFlight()">
                                    {{ flight.item.price | indracurrency }}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="booked_trip.booking_type === 'M'">
                    <div class="multicity-content">
                        <div class="multicity-details--left">
                            <ng-container *ngFor="let flight of booked_trip_flights; let i = index">
                                <div class="price-breakdown-count">
                                    <app-svg [svg]="flight.item.logo" [alt]="'priceBreakdown.alt.airlineLogo' | ibeadmin | async" class="price-breakdown__airline">
                                    </app-svg>
                                    <div class="price-breakdown-label">
                                        <div class="price-breakdown-title">
                                            <div class="multicity-details">
                                                <span class="destination">
													{{ flight.item.departureLocation }} -
													{{ flight.item.arrivalLocation }}
												</span>
                                                <p class="muted">
                                                    <a class="text-link" (click)="INDRA_handleDetailsClick(flight.item.details)" href="javascript:;" role="button">
														{{ 'priceBreakdown.link.details' | ibeadmin | async }}
													</a>
                                                </p>
                                            </div>
                                            <span class="datetime">{{ flight.item.flightDate | titlecase }}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <div class="multicity-details--right">
                            <!-- <div class="tag" *ngIf="INDRA_priceChange()">{{ 'priceBreakdown.text.newPrice' | ibeadmin | async }}</div> -->
                            <div>
                                <!--
								<div class="price-right line-through" *ngIf="INDRA_priceChange()">
									{{ INDRA_getFlightPrice(booked_trip.flights[0]) | indracurrency }}
								</div>
								-->
                                <div class="price-right" *ngIf="!bookAwardFlights">
                                    {{ booked_trip_flights[0].item.price | indracurrency }}
                                </div>
                                <div *ngIf="bookAwardFlights">
                                    {{ booked_trip_flights[0].item.price | indracurrency }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="booked_trip_flights.length > 0">

                    <div class="price-breakdown-count price-breakdown-count--total payment-table">
                        <div class="price-breakdown-label payment-table__line">
                            <div class="price-breakdown-title ">
                                {{ 'priceBreakdown.title.total' | ibeadmin | async }}
                            </div>

                            <div class="price-right bold">
                                {{ totalFlightPrice | indracurrency }}
                            </div>
                        </div>
                    </div>

                    <div class="fare-conditions-link__wrapper">
                        <a class="link" (click)="INDRA_handleFareAndTaxes()" [attr.aria-label]="'priceBreakdown.text.passengerPriceChange' | ibeadmin | async" href="javascript:;" role="button">
							{{ 'priceBreakdown.link.fareAndTaxesInformation' | ibeadmin | async }}
						</a>
                    </div>

                    <div class="fare-conditions-link__wrapper" *ngIf="showChangeFlightOption && booked_trip_flights.length > 0 && !isTTTBookingForCompletion && !isDupe">
                        <a class="link" (click)="INDRA_handleBackToChangeFlight()" [attr.aria-label]="'priceBreakdown.aria.resetAndChooseFlight' | ibeadmin | async" href="javascript:;" role="button">
							{{ 'priceBreakdown.link.changeFlights' | ibeadmin | async }}
						</a>
                    </div>
                </div>
            </ng-container>
            <!-- End Flights -->

            <div class="divider"></div>

            <!-- Discounts -->
            <div class="price-breakdown-list" *ngIf="isNormalBookingOrActiveTTT">
                <div class="price-breakdown-list--title">{{ 'priceBreakdown.title.discounts' | ibeadmin | async }}</div>
                <ul class="body">
                    <ng-container *ngIf="(!userInfo || (bookedTripDiscounts && bookedTripDiscounts.length)) && (userMiles >= 0)">
                        <li class="extras-feature extras-feature__price-breakdown" *ngFor="let discount of bookedTripDiscounts">
                            <div class="extras-feature__label">
                                <span>{{ 'priceBreakdown.text.milesAndGo' | ibeadmin | async }} </span>
                            </div>
                            <span class="price">
								- {{discount.value + currencyUnit | indracurrency }}
							</span>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="promocoCodesAndVoucher && promocoCodesAndVoucher.length > 0">
                        <li class="extras-feature extras-feature__price-breakdown" *ngFor="let discount of promocoCodesAndVoucher;">
                            <div class="extras-feature__label">
                                <span class="capitalize">
									{{ discount.type === VOUCHER_DISCOUNT ? ('priceBreakdown.text.voucher' | ibeadmin | async) : ('priceBreakdown.text.promocode' | ibeadmin | async) }}: {{ discount.code }}
									<ng-container *ngIf="discount.amountType === PERCENTAGE_TYPE_DISCOUNT">
										{{ discount.amountType === PERCENTAGE_TYPE_DISCOUNT ? '(' + discount.amount.toFixed(0) + '%)' : ''}} 
									</ng-container>
								</span>
                            </div>
                            <span class="price">
								<ng-container *ngIf="discount.amountType === PERCENTAGE_TYPE_DISCOUNT; else fixedTypeDiscountAmount">
									- {{ booked_trip_flights.length > 0 && discount.actualValue > 0 ? (discount.actualValue | indracurrency: discount.currencyCode) : '' }} 
								</ng-container>
								<ng-template #fixedTypeDiscountAmount>
									- {{ discount.amount | indracurrency: discount.currencyCode }} 
								</ng-template>
							</span>
                        </li>
                    </ng-container>
                    <!--
					<ng-container *ngIf="weakFlightsDiscount">
						<li class="extras-feature extras-feature__price-breakdown">
							<div class="extras-feature__label">
								<span class="capitalize">{{ 'priceBreakdown.text.weakFlightDiscount' | ibeadmin | async }}</span>
							</div>
							<span class="price">
								- {{ (weakFlightsDiscount? weakFlightsDiscount.amount + currency: 0) | indracurrency }}  
							</span>
						</li>
					</ng-container>
					-->
                </ul>
            </div>

            <div class="fare-conditions-link__wrapper" *ngIf="!isDupe && isNormalBookingOrActiveTTT">
                <a class="link" [class.disabled-div]="triggerHppRedFlag" (click)="INDRA_handleVoucherOrPromocode()" [attr.aria-label]="'priceBreakdown.aria.addManagePromocode' | ibeadmin | async" href="javascript:;" role="button">
					<span *ngIf="promocoCodesAndVoucher && promocoCodesAndVoucher.length > 0">
						{{ 'priceBreakdown.link.manageVoucherOrPromocodes' | ibeadmin | async }}
					</span>
					<span *ngIf="!promocoCodesAndVoucher || !promocoCodesAndVoucher.length || promocoCodesAndVoucher.length === 0">
						{{ 'priceBreakdown.link.addVoucherOrPromocode' | ibeadmin | async }}
					</span>
				</a>
            </div>

            <div class="price-breakdown-count price-breakdown-count--total payment-table" *ngIf="(bookedTripDiscounts && bookedTripDiscounts.length > 0) || (promocoCodesAndVoucher && promocoCodesAndVoucher.length > 0)">
                <div class="price-breakdown-label payment-table__line">
                    <div class="price-breakdown-title">
                        {{ 'priceBreakdown.title.total' | ibeadmin | async }}
                    </div>
                    <div class="price-right bold">
                        - {{ totalDiscount | indracurrency }}
                    </div>
                </div>
            </div>
            <!-- End Discounts -->

            <!-- Extras -->
            <div *ngIf="INDRA_showExtras()">
                <div class="divider"></div>

                <div class="price-breakdown-list">
                    <div class="price-breakdown-list--title">{{ 'priceBreakdown.title.extras' | ibeadmin | async }}</div>
                    <ul class="body">
                        <li *ngFor="let ancillary of ancillaries; let i = index" class="extras-feature extras-feature__price-breakdown ">
                            <app-svg title="Icon" class="ancillary-icon" svg="icons.svg#{{ ancillary.icon }}" [alt]="'priceBreakdown.alt.ancillaryIcon' | ibeadmin | async">
                            </app-svg>
                            <div class="extras-feature__wrapper">
                                <div class="extras-feature__label">
                                    <a class="text-link" [attr.aria-label]="('priceBreakdown.aria.open' | ibeadmin | async) + ' ' + (ancillary.translation | ibeadmin | async) + ' ' + ('priceBreakdown.aria.extraDialog' | ibeadmin | async)" (click)="INDRA_openAncillarySidebar(ancillary)"
                                        href="javascript:;" role="button">
                                        <ng-container *ngIf="!ancillary.isPack">
                                            {{ancillary.quantity}} x 
                                        </ng-container>

										{{ancillary.translation | ibeadmin | async}}
									</a>
                                    <span class="lighter">
										{{ ancillary.destination }}
									</span>
                                </div>
                                <span class="price">
									<div class="updated-price" *ngIf="ancillary.discounted && !isTTTBookingForCompletion">
										<span class="updated-price-tag">
											New price
										</span>
                                <span class="updated-price-original">
											{{ INDRA_printExtraOldCost(ancillary) | indracurrency }}
										</span>
                            </div>
                            {{ INDRA_printExtraCost(ancillary) | indracurrency }}
                            </span>

                </div>
                <!--
							<div *ngIf="INDRA_displayRemoveButton()">
								<app-svg *ngIf="isRemovingLoading === null || isRemovingLoading !== i" 
									(click)="INDRA_handleRemoveClick(ancillary, i)" 
									title="Remove" 
									class="remove__itemBasket"
									[attr.aria-label]="'Remove ' + ancillary.translation | ibeadmin | async"
									svg="icons.svg#general--close" 
									[alt]="'Remove icon'"></app-svg>
								<app-loading-circle class="remove__itemLoading" *ngIf="isRemovingLoading === i"></app-loading-circle>
							</div>
							-->
                        </li>

                        <li *ngIf="carbonOffset">
                            <div class="extras-feature extras-feature__price-breakdown" id="carbon_header">
                                <app-svg title="Carbon Offset" class="ancillary-icon" svg="icons.svg#plane_related--world_carbon" attr.tooltip="{{ 'priceBreakdown.text.carbonOffset' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.carbonOffsetIcon' | ibeadmin | async">
                                </app-svg>
                                <div class="extras-feature__label">
                                    <a class="link" [attr.aria-label]="'priceBreakdown.aria.openCarbonOffsetDialog' | ibeadmin | async" (click)="INDRA_handleCarbonOffset()" href="javascript:;" role="button">
                                                {{ 'priceBreakdown.text.carbonOffset' | ibeadmin | async }}
                                            </a>
                                </div>
                                <span class="price">{{ carbonOffset.amount.toFixed(2) + carbonOffsetCurrency | indracurrency }}</span>
                            </div>
                            <div id="toggle_carbon_section" class="tax_items" [attr.aria-expanded]="state == 'expanded' ? true : false" (click)="handleToggle()">
                                <p>{{ 'priceBreakdown.text.moreInformation' | ibeadmin | async }}</p>
                                <app-svg class="expand-icon" [ngClass]="['toggle-expand', state]"
                                        svg="icons.svg#general--arrow--bottom"
                                    [attr.aria-label]="'priceBreakdown.aria.openCarbonOffsetDialog' | ibeadmin | async" [alt]="'Arrow icon'"></app-svg>
                            </div>
                            <app-expand-collapse [state]="state">
                                <div role="listitem" *ngFor="let item of taxCarbonSummary"
                                    class="carbon-tax-listitem tax_items">
                                    <p>{{ item.label }}</p>
                                    <span class="price">{{ item.value + carbonOffsetCurrency | indracurrency }}</span>
                                </div>
                                <div class="border-top"></div>
                                <div class="tax_items" id="total_carbon_section">
                                    <p>{{ 'priceBreakdown.text.totalCarbonOffset' | ibeadmin | async }}</p>
                                    <span class="price">{{ carbonOffset.amount.toFixed(2) + carbonOffsetCurrency | indracurrency }}</span>
                                </div>
                            </app-expand-collapse>
                        </li>

                        <li *ngIf="danishGuaranteeFund" class="extras-feature extras-feature__price-breakdown ">
                            <app-svg title="Icon" class="ancillary-icon" svg="icons.svg#money_related--health_insurance_check" attr.tooltip="{{ 'priceBreakdown.text.danishFund' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.danishFundIcon' | ibeadmin | async">
                            </app-svg>
                            <div class="extras-feature__label">
                                <a class="link" [attr.aria-label]="'priceBreakdown.aria.openCarbonOffsetDialog' | ibeadmin | async" (click)="INDRA_danishGuaranteeFund()" href="javascript:;" role="button">
                                            {{ 'priceBreakdown.text.danishFund' | ibeadmin | async }}
                                        </a>
                            </div>
                            <span class="price">{{ danishGuaranteeFund.amount.toFixed(2) + danishFundCurrency | indracurrency }}</span>
                        </li>

                        <li *ngFor="let feature of extra_stopover" class="extras-feature extras-feature__price-breakdown ">
                            <app-svg title="Icon" class="ancillary-icon" svg="icons.svg#{{ feature.icon || 'general--plus'}}" attr.tooltip="{{feature.label}}" [alt]="feature.label + ' icon'">
                            </app-svg>
                            <div class="extras-feature__label">
                                <a class="link" [attr.aria-label]="'priceBreakdown.aria.openStopoverDialog' | ibeadmin | async" (click)="INDRA_handleOpenSidebar(feature)" href="javascript:;" role="button">
                                            {{feature.label}}
                                        </a>
                                <span class="lighter">{{ 'priceBreakdown.text.stopoverIn' | ibeadmin | async }} {{ feature.stopoverCityName }}</span>
                            </div>
                            <span class="price">{{ feature.value + feature.currency | indracurrency }}</span>
                        </li>

                        <li *ngIf="insurance" class="extras-feature extras-feature__price-breakdown ">
                            <app-svg title="Icon" class="ancillary-icon" svg="icons.svg#money_related--health_insurance_check" attr.tooltip="{{ 'priceBreakdown.text.insurance' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.insuranceIcon' | ibeadmin | async">
                            </app-svg>
                            <div class="extras-feature__label">
                                <a class="link" [attr.aria-label]="INDRA_getPlanDescription(insurance.extraInfo.insuranceItems.plan.ibeAdminKey) | titlecase" (click)="INDRA_handleInsurance(insurance.extraInfo.insuranceItems)" href="javascript:;" role="button">
                                            {{ INDRA_getPlanDescription(insurance.extraInfo.insuranceItems.plan.ibeAdminKey) }}
                                        </a>
                            </div>
                            <span class="price">{{ insurance.amount.toFixed(2) + insuranceCurrency | indracurrency }}</span>
                        </li>

                        <li *ngFor="let car of bookedCarRentals" class="extras-feature extras-feature__price-breakdown ">
                            <app-svg title="Icon" class="ancillary-icon" svg="icons.svg#services--rent_a_car" attr.tooltip="{{ 'priceBreakdown.text.rentACar' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.rentACarIcon' | ibeadmin | async">
                            </app-svg>
                            <div class="extras-feature__label">
                                <a class="link" href="javascript:;" role="button">
                                            {{ 'priceBreakdown.text.rentACarIn' | ibeadmin | async }} {{ car.location }}
                                        </a>
                            </div>
                            <span class="price">{{ car.price + car.currency | indracurrency }}</span>
                        </li>
                    </ul>
                </div>

                <div class="price-breakdown-count price-breakdown-count--total payment-table">
                    <div class="price-breakdown-label payment-table__line">
                        <div class="price-breakdown-title ">
                            {{ 'priceBreakdown.title.total' | ibeadmin | async }}
                        </div>
                        <div class="price-right bold">
                            {{ totalAncillariesPrice | indracurrency }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Extras -->

            <!-- Other charges -->
            <div *ngIf="booked_trip_flights.length > 0 && ((!INDRA_isUserLoggedIn() && adminFee > 0) || ccFee > 0)">
                <div class="divider"></div>

                <div class="price-breakdown-list">
                    <div class="price-breakdown-list--title">{{ 'priceBreakdown.title.otherCharges' | ibeadmin | async }}</div>
                    <ul class="body">
                        <li class="extras-feature extras-feature__price-breakdown" *ngIf="adminFee > 0">
                            <div class="extras-feature__label">
                                <span>{{ 'priceBreakdown.text.adminFee' | ibeadmin | async }}</span>
                                <span class="lighter">
                                        {{ 'priceBreakdown.text.willNotBeCharged' | ibeadmin | async }}
                                        <a class="link" 
                                            [attr.aria-label]="'priceBreakdown.aria.openLoginDialog' | ibeadmin | async" 
                                            (click)="showLoginModal()" 
                                            href="javascript:;" 
                                            role="button">
                                            {{ 'priceBreakdown.link.login' | ibeadmin | async }}
                                        </a>
                                    </span>
                            </div>
                            <span class="price">{{ adminFee.toFixed(2) + currencyUnit | indracurrency }}</span>
                        </li>
                        <li class="extras-feature extras-feature__price-breakdown" *ngIf="ccFee > 0">
                            <div class="extras-feature__label">
                                <span>{{ 'priceBreakdown.title.surcharge' | ibeadmin | async }}</span>
                            </div>
                            <span class="price">{{ ccFee.toFixed(2) + currencyUnit | indracurrency }}</span>
                        </li>
                    </ul>

                    <div class="price-breakdown-count price-breakdown-count--total payment-table">
                        <div class="price-breakdown-label payment-table__line">
                            <div class="price-breakdown-title ">
                                {{ 'priceBreakdown.title.total' | ibeadmin | async }}
                            </div>
                            <div class="price-right bold">
                                {{ totalOtherCharges.toFixed(2) + currencyUnit | indracurrency }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Other charges -->

            <!-- Pay to our partners -->
            <div *ngIf="booked_trip_flights.length > 0 && bookedHotels.length > 0">
                <div class="divider"></div>
                <div class="price-breakdown-list">
                    <div class="price-breakdown-list--title">{{ 'priceBreakdown.title.payToOurPartners' | ibeadmin | async }}</div>
                    <ul class="body">
                        <li class="extras-feature extras-feature__price-breakdown" *ngFor="let hotel of bookedHotels">
                            <div class="extras-feature__label">
                                <span>{{ 'priceBreakdown.text.hotelIn' | ibeadmin | async }} {{ hotel.routeParam.city }}</span>
                                <span class="lighter">{{ 'priceBreakdown.text.bookingCom' | ibeadmin | async }}</span>
                            </div>
                            <span class="price">{{ hotel.value + bookedTripExtrasCurrency | indracurrency }}</span>
                        </li>
                    </ul>
                </div>

                <div class="price-breakdown-count price-breakdown-count--total payment-table">
                    <div class="price-breakdown-label payment-table__line">
                        <div class="price-breakdown-title">
                            {{ 'priceBreakdown.title.total' | ibeadmin | async }}
                        </div>
                        <div class="price-right bold">
                            {{ bookedTripExtrasTotalPrice.toFixed(2) + bookedTripExtrasCurrency | indracurrency }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Pay to our partners -->

            <div *ngIf="bookedCarRentals.length > 0 || bookedHotels.length > 0" class="disclaimer container">
                {{ 'priceBreakdown.text.notBookingFlight' | ibeadmin | async }}
                <span *ngIf="bookedCarRentals.length">{{ 'priceBreakdown.text.car' | ibeadmin | async }} </span>
                <span *ngIf="bookedHotels.length">{{ 'priceBreakdown.text.hotel' | ibeadmin | async }} </span> {{ 'priceBreakdown.text.package' | ibeadmin | async }} {{ 'priceBreakdown.text.readAbout' | ibeadmin | async }}
                <a class="link link--external" href="{{'externalURLs.euProtection' | ibeadmincfg }}" target="_blank">
                        {{ 'priceBreakdown.text.euProtection' | ibeadmin | async }}
                    </a>
            </div>


            <!-- Create an account -->
            <div *ngIf="!INDRA_isUserLoggedIn() && isNormalBookingOrActiveTTT">
                <div class="divider"></div>
                <div class="price-breakdown-account">
                    <div>
                        <a class="text-link" href="javascript:void();" (click)="showLoginModal()" [attr.aria-label]="'priceBreakdown.aria.openDialogToLogin' | ibeadmin | async">
                                {{ 'priceBreakdown.link.loginCreateAccount' | ibeadmin | async }}
                            </a> {{ 'priceBreakdown.text.toGetDiscount' | ibeadmin | async }}
                    </div>
        <!--           <div> -->
        <!--               {{ 'priceBreakdown.text.dontHaveTapAccount' | ibeadmin | async }} -->
        <!--               <a class="link bold" href="javascript:void();" (click)="INDRA_handleSignUp()" [attr.aria-label]="'priceBreakdown.text.ariaAccountDialog' | ibeadmin | async"> -->
                            <!-- 	{{ 'priceBreakdown.link.createAccountNow' | ibeadmin | async }} -->
                            <!-- </a> {{ 'priceBreakdown.text.getDiscountsImmediately' | ibeadmin | async }} -->
        <!--           </div> -->
                </div>
            </div>
            <!-- End create an account -->
        </div>

        <!-- Booking totals -->
        <div class="sidebar-flight-extras" *ngIf="booked_trip_flights.length > 0">
            <ul class="body">
                <li class="extras-feature">
                    <div class="extras-feature__label">
                        <h3><strong>{{ 'priceBreakdown.title.passengersTotal' | ibeadmin | async }}</strong></h3>
                        <div class="extras-feature__label--note">
                            {{ 'priceBreakdown.text.feesCarrierChargesIncluded' | ibeadmin | async }}
                        </div>
                    </div>
                    <p class="price-total">
                        <ng-container *ngIf="totalBookingMilesToPay">
                            <!-- <strong class="price-total--original" *ngIf="!this.bookAwardFlights">{{ INDRA_printOriginalPrice() | indracurrency }}</strong> -->
                            <div>
                                <strong class="price-total--miles">{{ totalBookingMilesToPay | indracurrency }}</strong>
                                <strong> + </strong>
                                <strong>{{ totalBookingCashToPay | indracurrency }}</strong>
                            </div>
                        </ng-container>
                    </p>
                    <p class="price-total" *ngIf="!totalBookingMilesToPay">
                        <strong>{{ totalBookingCashToPay | indracurrency }}</strong>
                    </p>
                </li>
            </ul>
        </div>
    </ng-container>

    <ng-container *ngIf="isBookedTripLoaded && hasBookedTripRetrievalError">
        <div class="sidebar__body sl--scrollable" #sidebar__body>
            <app-notification [style]="'alert'" [icon]="'icons.svg#airport--delays'" [close]="true" [title]="'priceBreakdown.title.error' | ibeadmin | async">
                <div message>
                    <p>{{ 'priceBreakdown.text.errorMessage' | ibeadmin | async }}</p>
                </div>
            </app-notification>
        </div>
    </ng-container>

    <div #sidebar__footer class="sidebar__footer">
    </div>

</div>
